import React, { useState, Fragment, useEffect, useRef } from "react";
import ReactDom, { unmountComponentAtNode } from "react-dom";
import "./LayoutPanel.scss";
import LayoutSotableContent from './LayoutSotableContent';
import store from "app/store";
import LayoutPreview from "./LayoutPreview";
import $ from "jquery";
import { LoginUserType, ResponseCode, utils } from "utils/Utils";
import useGenerateToken from "components/Hook/useGenerateToken";
import { AsyncAjaxPut } from "components/Common/AsyncAjaxService";
import VGPopUp from "components/Controls/VGPopUp";
import Alert from "react-bootstrap/Alert";
import {setStyleDenotation,CreateSiteStylingFromString} from "components/SetLibrary/SetUtils"
import { DefaultSiteData } from "components/WebDesigner/Data/SiteData";
import { AlertConfirm } from "components/WebDesigner/ConfirmationPopups";
import { SetStartFromScratch } from "components/SetLibrary/SetLayoutList";

const LayoutContent = (props) => {

    const { ReactBusinessId, BusinessID, IsModifyAllowed, ReactUserID, UserType } = store.getState().Business;
    const [IsMessageOpen, setIsMessageOpen] = useState(false);
    const [Message, setMessage] = useState("");

    const VagaroAPIEnum = {
        LayoutChange: BusinessID + "/websitebuilders/changeslayout"
    }


    useEffect(() => {
        if (IsMessageOpen) {
            window.setTimeout(() => {
                if (IsMessageOpen) {
                    setIsMessageOpen(false);
                }
            }, 3000)
        }
    }, [IsMessageOpen]);


    const UseSetLayout = async (layoutID) => {
        const access_token = await useGenerateToken(props.dispatch);
        let userContext = {...DefaultSiteData.userContext};
        userContext.businessId = BusinessID;
        userContext.accessToken = access_token;
        userContext.userId = ReactUserID;
        //userContext.tokenExpiresAt = new Date().addHours(1);

        props.setLoading(true);
        CreateSiteStylingFromString(userContext,props.styleId,(style)=>{

            const siteString = {
                styling: style,
                imageUrls: style.imageMapping,
                lastPublishDate:"",
                homePageId: ""
            }
    
            let postData = {
                Content: JSON.stringify(siteString),
                Created_By: userContext.userId,
                layoutId: layoutID,
    
            }
            const content = JSON.stringify(postData);


            SetStartFromScratch(userContext,content ,(data)=>{
                let link = document.createElement("a");

                let result = data?.data?.data;
    
                if(!result){
                    AlertConfirm("Error starting from scratch");
                    props.setLoading(false);
                    return;
                }
    
                if(!result.layoutId || !result.styleId){
                    AlertConfirm("Error starting from scratch, existing layout or style found.");
                    props.setLoading(false);
                    return;
                }
              
                link.href = `/business/${result.styleId}/${result.layoutId}/designer`;
                document.body.appendChild(link);
                link.click();



            },(error)=>{
                AlertConfirm("Oops! Something went wrong", "Please try again later");
            });

        },(error)=>{
            AlertConfirm("Oops! Something went wrong", "Please try again later");

        });

    }

    const UseLayout = (layoutID) => {

        if(props.styleId.includes(setStyleDenotation)){

            

            UseSetLayout(layoutID);
            return;
        }

        let IsFromProapp = utils.IsFromProApp();
        if (typeof layoutID !== 'undefined' && layoutID !== null && layoutID !== "" && !IsFromProapp) {
            let a = document.createElement('a');
            a.target = '_self';
            a.href = "/admin/" + props.styleId + "/" + layoutID + "/designer";
            a.click();
        }
        else {
            let a = document.createElement('a');
            a.target = '_self';
            a.href = "/admin/" + props.styleId + "/" + layoutID + "/designer?isProApp=true";
            a.click();
        }
    }

    const UseSameLayout = (layoutID) => {
        let IsFromProapp = utils.IsFromProApp();
        if (typeof layoutID !== 'undefined' && layoutID !== null && layoutID !== "" && !IsFromProapp) {
            let a = document.createElement('a');
            a.target = '_self';
            a.href = "/business/" + props.styleId + "/" + layoutID + "/designer";
            a.click();
        }
        else {
            let a = document.createElement('a');
            a.target = '_self';
            a.href = "/business/" + props.styleId + "/" + layoutID + "/designer?isProApp=true";
            a.click();
        }
    }

    const StartFromScratchPopup = (layoutId) => {
        if (!IsModifyAllowed) {
            utils.ShowAlert("Message", "You do not have access to start from scratch.", "OpenDialog");
        }
        else {
            return ReactDom.render(
                <VGPopUp
                    id={"StartFromScratchPopupuselayout"}
                    show={true}
                    onHide={PopupClose}
                    title={"Your Website Content will be Deleted"}
                    dialogClassName="cancelauto-renew-alert"
                    body={
                        <div className="alertContent">
                            <p>Your customized content will be deleted and you will be starting over with a new layout.</p>
                        </div>
                    }
                    footer={
                        <Fragment>
                            <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Cancel</button>
                            <button className="w-button w-button-primary" onClick={() => StartFromScratch(layoutId)}>Change Layout</button>
                        </Fragment >
                    }
                    isRemoveTabModalIndex={false}
                    isShowFooter={true}
                    size={"md"}
                    backdrop={true}
                />,
                document.getElementById("OpenDialog"));
        }
    }

    const PopupClose = () => {
        unmountComponentAtNode(document.getElementById("OpenDialog"));
    };

    const StartFromScratch = async (layoutId) => {
        const access_token = await useGenerateToken(props.dispatch);
        if (UserType !== LoginUserType.VagaroAdmin && !IsModifyAllowed) {
            utils.ShowAlert("Alert", "Sorry, You do not have access to start from scratch.", "OpenDialog");
        }
        else {
            props.setLoading(true);
            if (utils.Validate(access_token) && IsModifyAllowed) {
                await AsyncAjaxPut(
                    VagaroAPIEnum.LayoutChange + `?layoutId=${layoutId}`,
                    access_token,
                    null,
                    function onSuccess(data) {
                        try {
                            if (
                                data != null && data.data != null && data.data.responseCode == ResponseCode.Success
                            ) {
                                if (data != null && data.data != null && data.data.data != null) {
                                    PopupClose();
                                    if (utils.Validate(data.data.data.layoutId)) {
                                        props.setLoading(false);
                                        setIsMessageOpen(true);
                                        setMessage("Website layout has been changed.");
                                        UseLayout(data.data.data.layoutId);
                                    }
                                    else {
                                        props.setLoading(false);
                                    }
                                }
                                else {
                                    PopupClose();
                                    props.setLoading(false);
                                }
                            }
                            else {
                                PopupClose();
                                props.setLoading(false);
                            }
                        }
                        catch (error) {
                            props.setLoading(false);
                            utils.appInsightTrack(ReactBusinessId, ReactUserID, "Start From Scratch", "", "");
                            utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                        }
                    },
                    function OnError() {
                        props.setLoading(false);
                        utils.appInsightTrack(ReactBusinessId, ReactUserID, "Start From Scratch", "", "");
                        utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                    }
                );
            }
            else {
                utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
            }
        }
    }

    const ViewLayout = async (Layoutimage, LayoutId) => {
        var access_token = await useGenerateToken(props.dispatch);
        return ReactDom.render(
            <LayoutPreview
                IsModifyAllowed={IsModifyAllowed}
                Layoutimage={Layoutimage}
                BusinessId={BusinessID}
                LayoutId={LayoutId}
                StyleId={props.styleId}
                AccessToken={access_token}
            />,
            document.getElementById("OpenDialog"))
    }

    const businessCurrentPageSize = props.layoutPagePageSize;
    const businessCurrentPage = useRef(props.layoutPageIndex);
    const businessPageSize = useRef(businessCurrentPageSize);
    const businessLoading = useRef(false);

    useEffect(() => {
        if (ReactBusinessId > 0) {
            handleScrollStyles()
        }
    }, [])


    const handleScrollStyles = (e) => {
        if (typeof ReactBusinessId !== 'undefined' && ReactBusinessId >= 0) {
            $('#layoutScrollDiv').on('scroll', function () {
                const bottom = parseInt($(this).scrollTop() + $(this).innerHeight()) >= parseInt($(this)[0].scrollHeight);
                if (bottom && businessLoading.current == false) {
                    businessLoading.current = true;
                    if ((businessCurrentPage.current * businessPageSize.current) < props.layouttotalitems) {
                        businessCurrentPage.current = businessCurrentPage.current + 1;
                        props.getLayoutList(props.styleId, true, false, businessCurrentPage.current, businessPageSize.current);
                    }
                }
            });
        }
    }

    const cardImgPath = window.location.href.indexOf("vagaro.com") > 0 ? ("https://d396040dc4cf62cf5770-d11e112dbdab6afc64c448f17b56c3c3.ssl.cf2.rackcdn.com/WB/") : ("https://f745786de3dd98dac855-36e09dc6f87385bab9d0e7ff5c0d38c7.ssl.cf2.rackcdn.com/WB/");

    const cardImgPlaceholder =
        "https://1a96a36bae7c8550901a-274b8a70320bb26e7a1e0ea7836ee429.ssl.cf2.rackcdn.com/PublicImages/Images/styale-thum-empty.gif";



    const GetStarted = async () => {
        window.location.href = "/admin/designservicepage";
    };

    const IsProChangeLayout = (businessLayoutID, id) => {
        if (utils.IsFromProApp() == true) {
            if (props.useupdatelayout == true) {
                if (id === businessLayoutID) {
                    UseSameLayout(id);
                }
                else {
                    StartFromScratchPopup(id);
                }
            }
        }
    }

    return (
        <Fragment>
            {ReactBusinessId == 0 &&
                <Fragment>
                    <LayoutSotableContent
                        layoutlist={props.layoutlist}
                        isLoading={props.isLoading}
                        setLoading={props.setLoading}
                        setLayoutList={props.setLayoutList}
                        getLayoutList={props.getLayoutList}
                        dispatch={props.dispatch}
                        styleId={props.styleId}
                        layouttotalitems={props.layouttotalitems}
                        layoutPageIndex={props.layoutPageIndex}
                        layoutPagePageSize={props.layoutPagePageSize}
                        allLayoutName={props.allLayoutName}
                        allLayoutNameOperation={props.allLayoutNameOperation}
                    />
                </Fragment>
            }
            {ReactBusinessId > 0 && props.layoutlist.length > 0 &&
                <div className={props.useupdatelayout == true ? "" : "layout-panel"}>
                    {IsMessageOpen &&
                        <div className="page-title">
                            <Alert isOpen={IsMessageOpen} variant="success" className="vg-alert-strip vg-passive">
                                <i className="fas fa-check-circle"></i> {Message}
                            </Alert>
                        </div>
                    }

                    <div className="change-layout-header-section">
                        <div className="page-title">{props.useupdatelayout == true ? "Change Layout" : "Select Website Layout"}</div>
                        <div className="title-with-btn">
                            {props.useupdatelayout == true &&
                                <Fragment>
                                    <div className="title-btn start-from-scratchbtn">
                                        <div>Looking to hire a website expert or migrate your current site? <a href={false} className="get-started" onClick={() => GetStarted()}>Get Started</a></div>
                                    </div>
                                </Fragment>
                            }
                        </div>
                    </div>
                    <div className="layout-cards-wrapper">
                        <div className="styles-cards-wrapper" id="layoutScrollDiv">
                            {props.layoutlist.map((list) => {
                                return (
                                    <div className="styles-card-col">
                                        <div className={(props.useupdatelayout == true && list.id === list.businessLayoutID) ? "styles-card selected" : "styles-card"} onClick={(e) => { utils.IsFromProApp() == true && UseLayout(list.id) }}>
                                            <div className="styles-card-thum-frame">
                                                <span className="dots"></span>
                                                <img className="styles-card-thum"
                                                    alt={list.layoutTitle}
                                                    style={{ backgroundImage: `url('${cardImgPath + list.layoutImage}')` }}
                                                    src={cardImgPlaceholder}
                                                />
                                                {props.useupdatelayout == true ?
                                                    list.id === list.businessLayoutID ?
                                                        <div className="styles-card-overlay">
                                                            <div className="btn-row">
                                                                <a href={false}
                                                                    onClick={(e) => { UseSameLayout(list.businessLayoutIDs) }}
                                                                    className={"w-button w-button-primary layout-" + list.businessLayoutIDs}
                                                                >
                                                                    Edit Layout
                                                                </a>
                                                            </div>
                                                        </div>
                                                        :
                                                        <div className="styles-card-overlay">
                                                            <div className="btn-row">
                                                                <a href={false}
                                                                    onClick={(e) => { StartFromScratchPopup(list.id) }}
                                                                    className={"w-button w-button-primary layout-" + list.id}
                                                                >
                                                                    Change Layout
                                                                </a>
                                                            </div>
                                                        </div>
                                                    :
                                                    <div className="styles-card-overlay">
                                                        <div className="btn-row">
                                                            <a href={false}
                                                                onClick={(e) => { UseLayout(list.id) }}
                                                                className={"w-button w-button-primary layout-" + list.id}
                                                            >
                                                                Use Website Layout
                                                            </a>
                                                        </div>
                                                        <div className="btn-row">
                                                            <a href={false}
                                                                className="w-button w-button-ghost" onClick={(e) => ViewLayout(list.layoutImage, list.id)}
                                                            >
                                                                Preview
                                                            </a>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            {props.useupdatelayout == true ? <Fragment> <div className="styles-card-item"><h3>{list.layoutTitle}</h3></div></Fragment> :
                                                <div className="styles-card-item">
                                                    <h3>{list.layoutTitle}{list.isActive && list.isSoftDelete &&
                                                        <span className="badge badge-secondary badge-inactive">
                                                            INACTIVE
                                                        </span>
                                                    }</h3>
                                                    <p>
                                                        {list.layoutDescription}
                                                    </p>
                                                </div>
                                            }

                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            }
        </Fragment >
    );
}

export default LayoutContent;